import axios from 'axios'
import VUE_APP_API_GAEA_URL from './getapi/gaea'

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50205/api/v1/'
  // apiURL = 'http://192.168.0.36:8092/api/v1/'
} else {
  apiURL = VUE_APP_API_GAEA_URL
}

let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
    "Authorization": localStorage.getItem('ms_token')
  }
});

export default http;